import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/cn";
/** Подсказка под полем формы: на мобиле скрыта, чтобы не раздувать экран. */
export function FieldHint({ children, className }) {
    return (_jsx("p", { className: cn("hidden text-xs leading-snug text-muted-foreground sm:block", className), children: children }));
}
